import createIcon from '../../createIcon';

/**
 * @component @name VideoChat
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkg0QzIuOSAyIDIuMDEgMi45IDIuMDEgNEwyIDIyTDYgMThIMjBDMjEuMSAxOCAyMiAxNy4xIDIyIDE2VjRDMjIgMi45IDIxLjEgMiAyMCAyWk0xNyAxM0wxNSAxMS4wMVYxM0MxNSAxMy41NSAxNC41NSAxNCAxNCAxNEg4QzcuNDUgMTQgNyAxMy41NSA3IDEzVjdDNyA2LjQ1IDcuNDUgNiA4IDZIMTRDMTQuNTUgNiAxNSA2LjQ1IDE1IDdWOC45OUwxNyA3VjEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VideoChat = createIcon('VideoChat', [
  [
    'path',
    {
      d: 'M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM17 13L15 11.01V13C15 13.55 14.55 14 14 14H8C7.45 14 7 13.55 7 13V7C7 6.45 7.45 6 8 6H14C14.55 6 15 6.45 15 7V8.99L17 7V13Z',
      key: '80nck2',
    },
  ],
]);

export default VideoChat;
